function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
//Limitless imports
import { withi18n } from "../../../../customer/components";
import ButtonLoadingAnimation from "../button-loading-animation/ButtonLoadingAnimation";
export const CORE_BUTTON_STYLES = {
  fontFamily: "'Work Sans', Helvetica, Arial, sans-serif",
  fontSize: "0.9375rem",
  fontWeight: 500,
  minWidth: 135,
  transition: ".25s all",
  height: 45,
  minHeight: 45,
  lineHeight: 1,
  padding: "6px 32px"
};
const LoginButton = ({
  classes,
  children,
  loading,
  disabled,
  loadingAnimaionColor,
  buttonClasses,
  containerClasses,
  t,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(FormControl, {
    className: containerClasses ? containerClasses : classes.loginButtonContainer
  }, /*#__PURE__*/React.createElement(Button, _extends({
    color: "primary",
    variant: "contained",
    classes: buttonClasses ? buttonClasses : {
      containedPrimary: classes.containedPrimary
    },
    fullWidth: false,
    disabled: loading || disabled
  }, rest), t(children)), /*#__PURE__*/React.createElement(ButtonLoadingAnimation, {
    loading: loading,
    color: loadingAnimaionColor
  }));
};
const styles = theme => ({
  loginButtonContainer: {
    display: "flex",
    justifyContent: "center",
    maxWidth: 325,
    margin: "auto"
  },
  containedPrimary: {
    backgroundColor: theme.palette.secondary.dark,
    ...CORE_BUTTON_STYLES,
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#145DFF"
    },
    "&:focus": {
      cursor: "pointer",
      backgroundColor: "#1F64FF"
    }
  },
  [theme.breakpoints.up("md")]: {
    loginButtonContainer: {
      justifyContent: "flex-start",
      margin: 0,
      width: "100%"
    }
  }
});
export default withStyles(styles)(withi18n(LoginButton));
LoginButton.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]).isRequired,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  t: PropTypes.func.isRequired,
  loadingAnimaionColor: PropTypes.string,
  buttonClasses: PropTypes.object,
  containerClasses: PropTypes.string
};
LoginButton.defaultProps = {
  loading: false,
  disabled: false,
  loadingAnimaionColor: "primary"
};